import { keysToSnake } from '#/api/adapters/wireCase';

/** 成立後更正 header 可改欄位（be doc f77b08e9 #85）。customerId 不在更正對話框提供。 */
export const REPAIR_REQUEST_CORRECTION_HEADER_KEYS = [
  'repairRequestDate',
  'receivedDate',
  'customerName',
  'contactName',
  'phone',
  'fax',
  'taxId',
  'address',
  'remark',
];

/** 成立後更正 line 可改欄位；SN 走另一支 route。 */
export const REPAIR_REQUEST_CORRECTION_LINE_KEYS = [
  'problemDescription',
  'accessories',
  'remark',
  'version',
  'salesDate',
  'warrantyExpiryDate',
];

function normalize(value) {
  if (value == null) {
    return null;
  }
  const trimmed = String(value).trim();
  return trimmed === '' ? null : trimmed;
}

function pickChanged(original, edited, keys) {
  const changed = {};
  for (const key of keys) {
    if (!Object.prototype.hasOwnProperty.call(edited ?? {}, key)) {
      continue;
    }
    const next = normalize(edited[key]);
    if (next !== normalize(original?.[key])) {
      changed[key] = next;
    }
  }
  return changed;
}

/**
 * PATCH `/{id}/corrections` body（camel）：只送有變動的 header 欄位與品項。
 * 空字串＝明確 null（清除）；未變動欄位不送。完全沒變動回 `null`（前端擋，不打 API）。
 *
 * @param {object} detail 目前 detail（camel）
 * @param {{ header?: object, lines?: object[], reason?: string }} values
 * @returns {object|null}
 */
export function toRepairRequestCorrectionBody(detail, values = {}) {
  const header = pickChanged(detail, values.header, REPAIR_REQUEST_CORRECTION_HEADER_KEYS);
  const originalLines = new Map((detail?.lines ?? []).map((line) => [String(line.id), line]));
  const lines = (values.lines ?? [])
    .map((line) => {
      const original = originalLines.get(String(line?.id));
      if (!original) {
        return null;
      }
      const changed = pickChanged(original, line, REPAIR_REQUEST_CORRECTION_LINE_KEYS);
      return Object.keys(changed).length > 0 ? { id: original.id, ...changed } : null;
    })
    .filter(Boolean);

  if (Object.keys(header).length === 0 && lines.length === 0) {
    return null;
  }

  return {
    updatedAt: detail?.record?.updatedAt ?? null,
    reason: normalize(values.reason),
    ...(Object.keys(header).length > 0 ? { header } : {}),
    ...(lines.length > 0 ? { lines } : {}),
  };
}

/** serial／add／remove 共用：reason＋updatedAt＋額外欄位。 */
export function toRepairRequestLineCommandBody(payload = {}, extraKeys = []) {
  const body = {
    reason: normalize(payload.reason),
    updatedAt: payload.updatedAt ?? payload.record?.updatedAt ?? null,
  };
  for (const key of extraKeys) {
    body[key] = normalize(payload[key]);
  }
  return body;
}

export function serializeRepairRequestCorrection(detail, values) {
  const body = toRepairRequestCorrectionBody(detail, values);
  return body ? keysToSnake(body) : null;
}

export function serializeRepairRequestSerialCorrection(payload) {
  return keysToSnake(toRepairRequestLineCommandBody(payload, ['serialNo']));
}

export function serializeRepairRequestAddLine(payload) {
  return keysToSnake(toRepairRequestLineCommandBody(payload, [
    'serialNo',
    'problemDescription',
    'accessories',
  ]));
}

export function serializeRepairRequestRemoveLine(payload) {
  return keysToSnake(toRepairRequestLineCommandBody(payload));
}
